import axios from 'axios';
import { GALLERYURL } from '../index';

export const getGalleryApi = (postData) => {
  return axios.post(GALLERYURL, JSON.stringify(postData));
};
